import React from 'react'
import { LineItem } from '../../../models/line-item'

export const LineItemCustomFields: React.FC<{ lineItem: LineItem }> = ({
  lineItem,
}) => {
  return (
    <>
      {lineItem.customFields.map(cf => {
        if (
          !cf.visibleInUI ||
          cf.value === null ||
          cf.type === 'product_id' ||
          cf.type === 'qrcode'
        ) {
          return null
        }

        let value = cf.value.toString()
        if (Array.isArray(cf.value)) {
          value = cf.value.join(', ')
        }

        if (value === '') return null

        return (
          <div key={cf.definitionId} className="vd-text-supplementary">
            {cf.title}: {value}
          </div>
        )
      })}
    </>
  )
}
